<template>
    <v-text-field
        v-on:input="[$emit('input', $event)]"
        :value="value"
        :prepend-inner-icon="icon"
        :rules="rules"
        :label="label"
        :placeholder="placeholder"
        outlined
        :disabled="disabled"
        @focus="$emit('focus')"
        @change="$emit('change')"
        @update:error="$emit('update:error', $event)"
        :prefix="prefix"
        :error-messages="errors"
        :validate-on-blur="validateOnBlur"
        :hide-details="hideDetails"
        :autofocus="autofocus"
        :single-line="singleLine"
        ref="input"
        :min="min"
        :max="max"
        :maxlength="zipCode ? '5' : maxlength"
        @keydown.enter="submit"
        :dense="dense"
        :loading="loading"
        :counter="counter"
        :type="password ? (show ? 'text' : 'password') : email ? 'email' : number ? 'number' : phone ? 'tel' : 'text'"
        :append-icon="password ? (show ? 'visibility' : 'visibility_off') : appendIcon"
        :class="[{ 'full-round': fullRound }, 'soli-text']"
        @click:append="$emit('append')"
    ></v-text-field>
</template>

<script>
export default {
    name: 'SoliText',
    props: {
        singleLine: { type: Boolean, default: false },
        dense: { type: Boolean, default: true },
        validateOnBlur: { type: Boolean, default: false },
        hideDetails: { type: [Boolean, String], default: false },
        prevent: { type: Boolean, default: false },
        value: {},
        label: {},
        icon: {},
        rules: {},
        disabled: {
            type: Boolean,
            default: false,
        },
        password: {
            type: Boolean,
            default: false,
        },
        show: {},
        errors: {},
        placeholder: {},
        email: {},
        prefix: {},
        number: { type: Boolean, default: false },
        phone: { type: Boolean, default: false },
        zipCode: { type: Boolean, default: false },
        autofocus: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
            default: null,
        },
        max: {
            type: Number,
            default: null,
        },
        fullRound: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        appendIcon: {
            type: String,
            default: null,
        },
        counter: {
            type: [Boolean, Number],
            default: false,
        },
        maxlength: {
            type: String,
            default: null,
        },
    },
    methods: {
        limitToDigits(event) {
            if (event.metaKey || event.ctrlKey || event.key.length > 1) return;
            if (event.key < '0' || event.key > '9') {
                event.preventDefault();
            }
        },
        submit(event) {
            if (this.prevent) {
                event.preventDefault();
                this.$emit('blur');
            }
            this.$emit('keydown', event);
        },
        focus() {
            this.$refs.input.focus();
        },
    },
    mounted() {
        //if (this.autofocus) this.focus();
        if (this.zipCode) {
            const input = this.$refs.input.$refs.input;
            if (input) input.addEventListener('keypress', this.limitToDigits);
        }
    },
    beforeDestroy() {
        if (this.zipCode) {
            const input = this.$refs.input?.$refs.input;
            if (input) input.removeEventListener('keypress', this.limitToDigits);
        }
    },
};
</script>
